import axios from 'axios';

// Axios Instance
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BE_HOST}${process.env.REACT_APP_GOOGLE_LOGIN_ENDPOINT}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
